import React from 'react';
import { PagoRequest } from '../../../models/Pago';
import { Receptor } from '../../../models/Catalogos';
import { REGIMEN_OPTIONS } from '../../../utils/regimen.options';
import AutoComplete from '../../Forms/Autocomplete';
import Input from '../../Forms/Input';
import Select from '../../Forms/Select';

const REGIMEN_OPT = REGIMEN_OPTIONS.map((o) => ({ value: o.value, label: o.secondLabel }))

interface PagosReceptorProps {
    cfdi: PagoRequest;
    validRequested: boolean;
    displayNoRfcWarning: boolean;
    receptorOptions: Receptor[];
    formasPago: { value: string, label: string }[];
    // Emitters
    onReceptorChange: (property: 'nombre' | 'rfc' | 'zip' | 'regimen') => (value: any) => void;
    onReceptorAutofill: (receptorAsString: string) => void;
    onComprobanteChange: (property: 'serie' | 'folio') => (value: any) => void;
    onSerieBlur: (value: string) => void;
    onPagoChange: (property: 'fecha' | 'monto' | 'formaDePago') => (value: any) => void;
}

function PagosReceptor({
    cfdi,
    validRequested,
    displayNoRfcWarning,
    receptorOptions,
    formasPago,
    onReceptorChange,
    onReceptorAutofill,
    onComprobanteChange,
    onSerieBlur,
    onPagoChange }: PagosReceptorProps) {

    const receptorNameOptions = receptorOptions.map(r => ({ label: r.name, value: JSON.stringify(r), template: <div><p className="_big">{r.name}</p><p className="_small">{r.rfc}</p></div> }))
    const receptorRFCOptions = receptorOptions.map(r => ({ label: r.rfc, value: JSON.stringify(r), template: <div><p className="_big">{r.rfc}</p><p className="_small">{r.name}</p></div> }))

    return (
        <div>
            <h4>Pago a registrar</h4>
            <div className="card table pagoRegister">
                <div className="cardBody">
                    <div className="row three lg-two xxs-one xs-gap-compressed">
                        <AutoComplete label="Nombre" hasError={(validRequested || displayNoRfcWarning) && !cfdi.receptor.nombre} value={cfdi.receptor.nombre} placeholder="Razón social de receptor" type="text"
                            noChangeOnSelect={true} options={receptorNameOptions} forcePropsValue={true} onChange={onReceptorChange('nombre')} onSelect={onReceptorAutofill} />
                        <AutoComplete label="RFC" hasError={(validRequested || displayNoRfcWarning) && !cfdi.receptor.rfc} value={cfdi.receptor.rfc} placeholder="RFC de receptor" type="text"
                            noChangeOnSelect={true} options={receptorRFCOptions} forcePropsValue={true} onChange={onReceptorChange('rfc')} onSelect={onReceptorAutofill} />
                    </div>
                    <div className="row three lg-two xxs-one xs-gap-compressed">
                        <Select label="Régimen" hasError={validRequested && !cfdi.receptor.regimen} value={cfdi.receptor.regimen} onChange={onReceptorChange('regimen')} placeholder="Régimen fiscal del receptor" options={REGIMEN_OPT} />
                        <Input label="Código Postal" hasError={validRequested && ((cfdi.receptor.zip || '').length !== 5)} value={cfdi.receptor.zip} onChange={onReceptorChange('zip')} type="text" placeholder="Codigo Postal Domicilio Fiscal" />
                        <div className='row lg-hidden' />

                        <Input label="Serie de pago" hasError={validRequested && !cfdi.serie} value={cfdi.serie} onChange={onComprobanteChange('serie')} type="text" placeholder="Serie" onBlur={onSerieBlur} />
                        <Input label="Folio" hasError={validRequested && !cfdi.folio} value={cfdi.folio} onChange={onComprobanteChange('folio')} type="text" placeholder="Folio" />
                    </div>
                    <div className="row three lg-two md-two sm-one">
                        <Input type="date" label="Fecha de pago" hasError={validRequested && !cfdi.pagos[0].fecha} value={cfdi.pagos[0].fecha} onChange={onPagoChange('fecha')} placeholder="Fecha al recibir el pago" />
                        <Select label={'Selecciona como recibirás tu pago'} hasError={validRequested && !cfdi.pagos[0].formaDePago} value={cfdi.pagos[0].formaDePago} onChange={onPagoChange('formaDePago')} options={formasPago} placeholder='Elige una de las opciones' />
                        <Input type="number" isCurrency={true} hasError={validRequested && !cfdi.pagos[0].monto} label="Monto total" value={cfdi.pagos[0].monto} placeholder="" onChange={onPagoChange('monto')} min={0.01} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PagosReceptor;
